import _get from 'lodash/get';
import dayjs from 'dayjs';
import { StringColumn, NumericalColumn, CategoricalColumn } from 'baseui/data-table';
import { EMPTY_STRING, EMPTY_NUMBER } from 'commons-ui';

export const COL_NAMES = {
	confiscationId: 'confiscationId',
	uid: 'uid',
	tid: 'tid',
	refundType: 'refundType',
	confiscationType: 'confiscationType',
	createdAt: 'createdAt',
	updatedAt: 'updatedAt',
	status: 'status',
	createdBy: 'createdBy',
	actualCoinsToConfiscate: 'actualCoinsToConfiscate',
	addedCoinsToConfiscate: 'addedCoinsToConfiscate',
	rejectionReason: 'rejectionReason',
	amount: 'amount',
	transactionAmount: 'transactionValue',
	approvedOrRejectedBy: 'approvedOrRejectedBy',
	revertTid: 'revertTid',
	freshdeskTicketId: 'freshdeskTicketId',
	deductionType: 'deductionType',
	freshdeskTicketHyperlink: 'freshdeskTicketHyperlink',
	reportedBy: 'reportedBy',
	reportedOn: 'reportedOn'
};

export const columnConfigs = [
	StringColumn({
		title: 'Confiscation Id',
		mapDataToValue: (data: any) => data[COL_NAMES.confiscationId] || EMPTY_STRING
	}),
	NumericalColumn({
		title: 'Zupee User Id',
		mapDataToValue: (data: any) => data[COL_NAMES.uid] || EMPTY_NUMBER
	}),
	NumericalColumn({
		title: 'Transaction Id',
		minWidth: 100,
		mapDataToValue: (data: any) => data[COL_NAMES.tid] || EMPTY_NUMBER
	}),
	NumericalColumn({
		title: 'Amount(D+W)',
		minWidth: 100,
		mapDataToValue: (data: any) => data[COL_NAMES.amount] || EMPTY_NUMBER
	}),
	StringColumn({
		title: 'Refund Type',
		mapDataToValue: (data: any) => data[COL_NAMES.refundType] || EMPTY_STRING
	}),
	StringColumn({
		title: 'Confiscation Type',
		mapDataToValue: (data: any) => data[COL_NAMES.confiscationType] || EMPTY_STRING
	}),
	CategoricalColumn({
		title: 'Status',
		mapDataToValue: (data: any) => data[COL_NAMES.status] || EMPTY_STRING
	}),
	StringColumn({
		title: 'Rejection Reason',
		mapDataToValue: (data: any) => data[COL_NAMES.rejectionReason] || EMPTY_STRING
	}),
	StringColumn({
		title: 'Created By',
		minWidth: 100,
		mapDataToValue: (data: any) => data[COL_NAMES.createdBy] || EMPTY_STRING
	}),
	StringColumn({
		title: 'Approved Or Rejected By',
		mapDataToValue: (data: any) => data[COL_NAMES.approvedOrRejectedBy] || EMPTY_STRING
	}),
	NumericalColumn({
		title: 'Revert Tid',
		mapDataToValue: (data: any) => data[COL_NAMES.revertTid] || EMPTY_NUMBER
	}),
	StringColumn({
		title: 'Freshdesk Ticket Id / Email Sub Line',
		mapDataToValue: (data: any) => data[COL_NAMES.freshdeskTicketId] || EMPTY_STRING
	}),
	StringColumn({
		title: 'Created At',
		mapDataToValue: (data: any) => {
			return _get(data, COL_NAMES.createdAt)
				? dayjs(new Date(_get(data, COL_NAMES.createdAt))).format('DD-MM-YYYY hh:mm A')
				: 'NA';
		}
	}),
	StringColumn({
		title: 'Updated At',
		mapDataToValue: (data: any) => {
			return _get(data, COL_NAMES.updatedAt)
				? dayjs(new Date(_get(data, COL_NAMES.updatedAt))).format('DD-MM-YYYY hh:mm A')
				: 'NA';
		}
	})
];
